import React from "react";
import { Quote } from "lucide-react";
import { SHORT_QUOTES, IMAGES } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function SocialProof() {
  const r = useReveal();
  return (
    <section className="bg-ls-alt py-20 md:py-28 border-t" style={{ borderColor: "var(--ls-border)" }}>
      <div ref={r.ref} className={`max-w-7xl mx-auto px-5 md:px-8 ${r.className}`}>
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image + stat */}
          <div className="relative">
            <div className="hero-frame rounded-lg overflow-hidden bg-black">
              <img
                src={IMAGES.crew}
                alt="More leads, more jobs, bigger impact"
                className="w-full aspect-square object-cover"
              />
            </div>
            <div
              className="absolute -top-6 -right-4 md:right-6 px-6 py-4 text-center shadow-2xl"
              style={{ backgroundColor: "var(--ls-orange)", borderRadius: "6px" }}
            >
              <div className="font-display text-5xl text-[#1a0f06] leading-none">14</div>
              <div className="text-xs font-bold uppercase tracking-[0.14em] text-[#5c3410] mt-1">
                Jobs / month avg.
              </div>
            </div>
          </div>

          {/* Quotes */}
          <div>
            <p className="ls-eyebrow mb-4">Real home service pros</p>
            <h2 className="font-display text-white text-[9vw] sm:text-5xl md:text-6xl mb-8">
              Pros who book more and chase less.
            </h2>
            <div className="space-y-4">
              {SHORT_QUOTES.map((q, i) => (
                <div key={i} className="card-dark p-5 flex gap-4 items-start">
                  <Quote className="w-6 h-6 text-orange shrink-0 mt-1" />
                  <p className="text-lg text-[#ece5da] font-medium leading-snug">{q}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
